import { Typography } from '@mui/material';
import { FC } from 'react';

import { regularTextColor } from 'assets/styles/_palette';

interface ITitleTextProps {
	title: string;
	styles?: Record<string, string>;
}

export const RegularText: FC<ITitleTextProps> = ({ title, styles }) => {
	return (
		<Typography
			sx={{
				fontSize: '16px',
				fontWeight: '400',
				lineHeight: '24px',
				letterSpacing: '0.15px',
				color: regularTextColor,
				...styles,
			}}
		>
			{title}
		</Typography>
	);
};
